import {
  BufferOverflow_DROP_LATEST_getInstance2lljjnmqeitb9 as BufferOverflow_DROP_LATEST_getInstance,
  BufferOverflow_SUSPEND_getInstance3j24qbb4wnzlq as BufferOverflow_SUSPEND_getInstance,
  BufferOverflow_DROP_OLDEST_getInstance3u1027cpcc1wz as BufferOverflow_DROP_OLDEST_getInstance,
} from './BufferOverflow.mjs';
import {
  BufferedChannel3lgkhzot5gmk6 as BufferedChannel,
  get_BUFFERED29hqqqmuwfwgo as get_BUFFERED,
  access$_get_sendSegment__111kgq3e41ruajnjr0f as access$_get_sendSegment__111kgq,
  access$_get_sendersAndCloseStatus__tvw29s1hsu1qz6ckz7z as access$_get_sendersAndCloseStatus__tvw29s,
  access$_get_isClosedForSend0__sm8f7ad6w3wkg5hm6q as access$_get_isClosedForSend0__sm8f7a,
  get_SEGMENT_SIZE3avqnmtdqy204 as get_SEGMENT_SIZE,
  access$findSegmentSend1rq2hoj4hiojx as access$findSegmentSend,
  access$updateCellSend1n524tbdorfh1 as access$updateCellSend,
  access$prepareSenderForSuspensionhe35w06znfdm as access$prepareSenderForSuspension,
} from './BufferedChannel.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  _ChannelResult___get_isSuccess__impl__odq1z912b5ogo8613be as _ChannelResult___get_isSuccess__impl__odq1z9,
  _ChannelResult___get_isClosed__impl__mg7kuu1g5u2zmbzbfb4 as _ChannelResult___get_isClosed__impl__mg7kuu,
  Companion_getInstance2d24j5bn8excb as Companion_getInstance,
  _ChannelResult___get_holder__impl__pm9gzw2tjepaj1eg2kq as _ChannelResult___get_holder__impl__pm9gzw,
  ChannelResult__exceptionOrNull_impl_16ei302e9q7b2jc90dz as ChannelResult__exceptionOrNull_impl_16ei30,
  Closed8t4xgopf7j5r as Closed,
} from './Channel.mjs';
import { callUndeliveredElementCatchingException6xwxmojd3rq1 as callUndeliveredElementCatchingException } from '../internal/OnUndeliveredElement.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  dividelr0uqtdj497z as divide,
  modulooi4g1kq3dmtt as modulo,
  convertToInty04h231mmjoh as convertToInt,
  multiply2k9eolhnz1bjv as multiply,
  add2suhfggl4zvkk as add,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Waiter3lxa2a79zyo0g as Waiter } from '../Waiter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function trySendImpl($this, element, isSendOp) {
  return $this.v1c_1 === BufferOverflow_DROP_LATEST_getInstance() ? trySendDropLatest($this, element, isSendOp) : trySendDropOldest($this, element);
}
function trySendDropLatest($this, element, isSendOp) {
  var result = protoOf(BufferedChannel()).h1b.call($this, element);
  if (_ChannelResult___get_isSuccess__impl__odq1z9(result) || _ChannelResult___get_isClosed__impl__mg7kuu(result))
    return result;
  if (isSendOp) {
    var tmp0_safe_receiver = $this.y18_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp1_safe_receiver;
    }
  }
  return Companion_getInstance().j1a(Unit_instance);
}
function trySendDropOldest($this, element) {
  var tmp4 = get_BUFFERED();
  var tmp$ret$0;
  $l$block_5: {
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
    var segment = access$_get_sendSegment__111kgq($this).kotlinx$atomicfu$value;
    $l$loop_0: while (true) {
      var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s($this).atomicfu$getAndIncrement$long();
      var s = sendersAndCloseStatusCur & 1152921504606846975n;
      var closed = access$_get_isClosedForSend0__sm8f7a($this, sendersAndCloseStatusCur);
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = divide(s, fromInt(other));
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$3 = modulo(s, fromInt(other_0));
      var i = convertToInt(tmp$ret$3);
      if (!(segment.m10_1 === id)) {
        var tmp0_elvis_lhs = access$findSegmentSend($this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp_0;
          if (closed) {
            return Companion_getInstance().c1b($this.d1a());
          } else {
            continue $l$loop_0;
          }
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      switch (access$updateCellSend($this, segment, i, element, s, tmp4, closed)) {
        case 0:
          segment.v19();
          return Companion_getInstance().j1a(Unit_instance);
        case 1:
          return Companion_getInstance().j1a(Unit_instance);
        case 2:
          if (closed) {
            segment.l19();
            return Companion_getInstance().c1b($this.d1a());
          }

          var tmp2_safe_receiver = (!(tmp4 == null) ? isInterface(tmp4, Waiter()) : false) ? tmp4 : null;
          if (tmp2_safe_receiver == null)
            null;
          else {
            access$prepareSenderForSuspension($this, tmp2_safe_receiver, segment, i);
          }

          var tmp0 = segment.m10_1;
          // Inline function 'kotlin.Long.times' call

          var other_1 = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call

          var this_0 = multiply(tmp0, fromInt(other_1));
          var tmp$ret$10 = add(this_0, fromInt(i));
          $this.a1b(tmp$ret$10);
          return Companion_getInstance().j1a(Unit_instance);
        case 4:
          if (s < $this.e1a()) {
            segment.v19();
          }

          return Companion_getInstance().c1b($this.d1a());
        case 5:
          segment.v19();
          continue $l$loop_0;
        case 3:
          // Inline function 'kotlin.error' call

          var message = 'unexpected';
          throw IllegalStateException().o(toString(message));
      }
    }
  }
  return tmp$ret$0;
}
var ConflatedBufferedChannelClass;
function ConflatedBufferedChannel() {
  if (ConflatedBufferedChannelClass === VOID) {
    class $ extends BufferedChannel() {
      constructor(capacity, onBufferOverflow, onUndeliveredElement) {
        onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
        super(capacity, onUndeliveredElement);
        this.u1c_1 = capacity;
        this.v1c_1 = onBufferOverflow;
        // Inline function 'kotlin.require' call
        if (!!(this.v1c_1 === BufferOverflow_SUSPEND_getInstance())) {
          var message = 'This implementation does not support suspension for senders, use ' + getKClass(BufferedChannel()).j1() + ' instead';
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.u1c_1 >= 1)) {
          var message_0 = 'Buffered channel capacity must be at least 1, but ' + this.u1c_1 + ' was specified';
          throw IllegalArgumentException().n2(toString(message_0));
        }
      }
      b1b() {
        return this.v1c_1.equals(BufferOverflow_DROP_OLDEST_getInstance());
      }
      *g1b(element, $completion) {
        // Inline function 'kotlinx.coroutines.channels.onClosed' call
        var this_0 = trySendImpl(this, element, true);
        var tmp = _ChannelResult___get_holder__impl__pm9gzw(this_0);
        if (tmp instanceof Closed()) {
          ChannelResult__exceptionOrNull_impl_16ei30(this_0);
          var tmp0_safe_receiver = this.y18_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            addSuppressed(tmp1_safe_receiver, this.d1a());
            throw tmp1_safe_receiver;
          }
          throw this.d1a();
        }
        return Unit_instance;
      }
      h1b(element) {
        return trySendImpl(this, element, false);
      }
    }
    initMetadataForClass($, 'ConflatedBufferedChannel', VOID, VOID, VOID, [1, 0]);
    ConflatedBufferedChannelClass = $;
  }
  return ConflatedBufferedChannelClass;
}
//region block: exports
export {
  ConflatedBufferedChannel as ConflatedBufferedChannel16nes42ao4b78,
};
//endregion

//# sourceMappingURL=ConflatedBufferedChannel.mjs.map
